import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetProjectsQuery } from "../features/projects/projectsApi";
import {
  useGetTasksQuery,
  useUpdateTaskMutation,
} from "../features/tasks/tasksApi";
import { useGetMembersQuery } from "../features/team/memberApi";

const AddTask = () => {
  const { taskId } = useParams();
  const { data: projects, isSuccess: isProjectsSuccess } =
    useGetProjectsQuery();
  const { data: members, isSuccess: isMembersSuccess } = useGetMembersQuery();
  const { data: tasks, isSuccess } = useGetTasksQuery();

  const thisTask = tasks?.find((t) => t.id == taskId);
  const { taskName, teamMember, project, deadline, id } = thisTask || {};
  const { name: memberName } = teamMember || {};
  const { projectName } = project || {};
  //   console.log(thisTask);

  const [name, setName] = useState("");
  const [assignTo, setAssignTo] = useState("");
  const [selected, setSelected] = useState("");
  const [date, setDate] = useState("");

  const selectedMemberDetails = members?.find(
    (mem) => mem.name === memberName
  );
  useEffect(() => {
    setName(taskName);
    setAssignTo(memberName);
    setDate(deadline);
    setSelected(projectName);
    setMember(selectedMemberDetails)
  }, [isSuccess, isMembersSuccess]);

  const [member, setMember] = useState({});
  const [ppproject, setProject] = useState({});

  const navigate = useNavigate();

  const [updateTask, { data, isSuccess: isUpdateSuccess }] =
    useUpdateTaskMutation();

  const testData = {
    id: id,
    taskName: name,
    teamMember: member,
    project: ppproject,
    deadline: date,
  };
  console.log(testData);
  const handleSubmit = (e) => {
    e.preventDefault();
    updateTask({
      id: id,
      taskName: name,
      teamMember: member,
      project: ppproject,
      deadline: date,
    });
    navigate("/");
  };
  const handleProjectChange = (e) => {
    const selectedProjectDetails = projects.find(
      (pro) => pro.projectName === e.target.value
    );
    setSelected(e.target.value);
    setProject(selectedProjectDetails);
  };
  const handleMemberChange = (e) => {
    const selectedMemberDetails = members.find(
      (mem) => mem.name === e.target.value
    );
    setAssignTo(e.target.value);
    setMember(selectedMemberDetails);
  };

  return (
    <div className="text-[#111827]">
      <div className="container relative">
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
            Edit Task for Your Team
          </h1>

          <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="fieldContainer">
                <label htmlFor="lws-taskName">Task Name</label>
                <input
                  type="text"
                  name="taskName"
                  id="lws-taskName"
                  required
                  placeholder="Implement RTK Query"
                  value={name ?? "Set a name"}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="fieldContainer">
                <label>Assign To</label>
                <select
                  name="teamMember"
                  id="lws-teamMember"
                  required
                  value={assignTo}
                  onChange={handleMemberChange}
                >
                  {isMembersSuccess &&
                    members?.map((member) => (
                      <option key={member.name} value={member.name}>
                        {member.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="fieldContainer">
                <label htmlFor="lws-projectName">Project Name</label>
                <select
                  id="lws-projectName"
                  name="projectName"
                  required
                  value={selected}
                  onChange={handleProjectChange}
                >
                  {isProjectsSuccess &&
                    projects?.map((project) => (
                      <option
                        key={project.projectName}
                        value={project.projectName}
                      >
                        {project.projectName}
                      </option>
                    ))}
                </select>
              </div>

              <div className="fieldContainer">
                <label htmlFor="lws-deadline">Deadline</label>
                <input
                  type="date"
                  name="deadline"
                  id="lws-deadline"
                  required
                  value={date ?? "yyyy-MM-dd"}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>

              <div className="text-right">
                <button type="submit" className="lws-submit">
                  Save
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AddTask;
